import { useState } from 'react'
import { UseFormReset } from 'react-hook-form'
import { getKyousouApiClient , ApiErrorResponse, handleError } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { ExecutionPlanApiData, SlideExecutionPlan, ExecutionPlanFormData } from './types'

export const useExecutionPlanUpdate = () => {
  const [isUpdating, setIsUpdating] = useState(false)
  const { showSnackBar } = useSnackBar()

  const updateExecutionPlan = async (
    businessIdeaId: string,
    data: ExecutionPlanApiData,
    setSlideExecutionPlan: (slideExecutionPlan: SlideExecutionPlan) => void,
    reset: UseFormReset<ExecutionPlanFormData>
  ) => {
    setIsUpdating(true)
    const apiClient = getKyousouApiClient()

    try {
      const response = await apiClient.business.slideExecutionUpdateUpdate({
        businessIdeaId,
        ...data,
      })

      if (response.data?.executionPlan) {
        setSlideExecutionPlan(response.data.executionPlan)

        try {
          reset({
            resource: response.data.executionPlan.resource,
            maxPeriod: response.data.executionPlan.maxPeriod,
            scheduleItems: JSON.parse(response.data.executionPlan.scheduleItems || '[]'),
          })

          showSnackBar(['実行計画&必要なリソースの更新が完了しました'], 'success')
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError)
          showSnackBar(['実行計画&必要なリソースのデータの読み込みに失敗しました。'], 'error')
        }
      }
    } catch (e) {
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsUpdating(false)
    }
  }

  return {
    isUpdating,
    updateExecutionPlan,
  }
}
